import React from "react";
import GetButtons from "./getButtons";
import { ExportToCsv } from "export-to-csv";
import formatedDate from "../../utilities/formatedDate";
import { getActiveCompany, getAllDealers } from "../../api";
import { toast } from "react-toastify";

const GetExport = (props) => {
  const {columns, exportedData, name , type} = props;
  console.log("this are columns",columns,exportedData)
  const timestamp = new Date().toISOString().replace(/:/g, "-");
  const filename = `${name}_${timestamp}.csv`;

  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers: columns.map((c) => c.header),
    filename: filename,
  };

  const handleExportData = async () => {
    console.log("this are columns")
    if(exportedData.length === 0) {
      toast.error("No data found to export!")
    }else{
      if(type== "company"){
        const response = await  getActiveCompany()
        const companyData = response.data.result
        const exportedData = companyData?.map((item) => ({
          Name: item?.client_company_name,
          Code: item?.client_company_code,
          Manufacturer: item?.manufacturer,
          City: item?.city,
          Status: item?.is_active ? "Active" : "Deactivate",
          Created_on: formatedDate(item?.create_at),
        }));
        csvOptions.headers = Object.keys(exportedData[0]);
        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(exportedData);
       
      } else if(type== "dealer"){
        const response = await  getAllDealers()
        const dealerData = response.data.result
        const exportedData = dealerData.map((item) => {

          const baseItem = {
          Name: item.dealer_name,
          DealerCode: item.dealer_code,
          Company: item.company_id,
          Email: item.email,
          Mobile: item.phone_number,
          City: item.city,
          Navision: item.engage_sync_navision,
          Created_on: formatedDate(item.created_at),
          Status: item.is_active ? 'Active' : 'Deactivate',
          }

          if (item?.commission_percent !== undefined) {
            baseItem.Commission_Percentage = item.commission_percent;
          }
          if (item?.state !== undefined) {
            baseItem.State = item.state;
          }
          return baseItem; 

      });

       
        csvOptions.headers = Object.keys(exportedData[0]);
        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(exportedData);
       
  
      } else if(type== "cashify"){
        
        const newExportedData = exportedData.map((item) => {
          // Build the object in the desired order
          const baseItem = {
            Policy_No: item?.Policy_No,
            Certificate: item?.Certificate,
            Product_Name: item?.Product_Name,
            Company: item?.Company,
          };
          // Insert Sale_Date after Company if defined
          if (item?.Sale_Date !== undefined) {
            baseItem.Sale_Date = item.Sale_Date;
          }
          // Continue with the rest of the fields
          baseItem.Start_date = item?.Start_date;
          baseItem.End_date = item?.End_date;
          if (item?.device_value !== undefined) {
            baseItem.device_value = item.device_value;
          }
           if (item?.Cost_Slabs !== undefined) {
            baseItem.Cost_Slabs = item.Cost_Slabs;
          }
          baseItem.Amount = item?.Amount;
          if (item?.Ea_Service_Fess !== undefined) {
            baseItem.Ea_Service_Fees = item.Ea_Service_Fess;
          }
          if (item?.Isurance_Fees_percentage !== undefined) {
            baseItem.Isurance_Fees_percentage = item.Isurance_Fees_percentage;
          }
          if (item?.Marketing_Fees_percentage !== undefined) {
            baseItem.Marketing_Fees_percentage = item.Marketing_Fees_percentage;
          }
          
          if (item?.Brand_Royalty !== undefined) {
            baseItem.brand_royalty = item.Brand_Royalty;
          }
          if (item?.device_value !== undefined) {
            baseItem.device_value = item.device_value;
          }
          baseItem.Created_At = item?.Created_At;
          baseItem.Created_By = item?.Created_By;
          baseItem.Status = item?.Status;
          if (item?.partnership_code !== undefined) {
            baseItem.Partner_Code = item.partnership_code;
          }
           if (item?.Partner_Email !== undefined) {
            baseItem.Partner_Email = item.Partner_Email;
          }
          return baseItem;
        });

        console.log("hii",newExportedData)
        csvOptions.headers = Object.keys(newExportedData[0]);
        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(newExportedData);
      }
      else{
        csvOptions.headers = Object.keys(exportedData[0]);
        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(exportedData);
      }
    }
  
  };

  return (
    <>
      <GetButtons onClick={handleExportData} type="export" />
    </>
  );
};

export default GetExport;
